import { ReactElement } from 'react';
import { getLabelFallback  } from '@utils/utils';
import { useSelector } from 'react-redux';

const LoginBanner = () : ReactElement => {

    const config = useSelector(state => state.cart.config);  

    const onClickFunction = config.callFromComponentToGl.onLogin;

    return (
        <div className="login-banner">
            <label className="login-banner-text">
                { getLabelFallback('LOGIN_LABEL') } 
                <button className="login-banner-button primary-button" onClick={onClickFunction}>{getLabelFallback('LOGIN_LINK') }</button>
            </label>
        </div>       
    );
}

export default LoginBanner;